import angular from "angular";
import station from "../station";
import core from "../../core/core.module";

angular
    .module('stationsControl.syncStations', [station, core])
    .component('syncStations', {
        controller: ['Station', 'notifier', controller],
        template: require('./sync-stations.component.html'),
        bindings: {
            lastStationSync: '<'
        }
    });

function controller(Station, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentSyncId = null;
        $ctrl.loadCount = 0;
        $ctrl.requestsCount = 0;
        $ctrl.maxRequestsCount = 350;
        $ctrl.isComplete = false;
    };

    $ctrl.sync = function () {
        if (!confirm('Вы действительно хотите начать синхронизацию?')) {
            return;
        }
        $ctrl.loading = true;
        loadStations();
    };

    function loadStations() {
        Station
            .sync($ctrl.currentSyncId)
            .then(
                function (response) {
                    $ctrl.currentSyncId = response.data.stationSyncId;
                    $ctrl.requestsCount = response.data.requestsCount;
                    $ctrl.isComplete = response.data.isComplete;
                    if ($ctrl.isComplete) {
                        $ctrl.maxRequestsCount = $ctrl.requestsCount;
                        $ctrl.loading = false;
                    } else {
                        loadStations();
                    }
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    }

}

export default 'stationsControl.syncStations';


// WEBPACK FOOTER //
// ./resources/assets/modules/stations-control/sync-stations/sync-stations.component.js